import Modal from "common/Modal/Modal.tsx";
import Text from "common/Typography/Text";
import { GroupData, LanguageNameSpaces, SubGroupType } from "@shared/types";
import Flex from "common/Boxes/Flex.tsx";
import { disabledStyle } from "common/Buttons/styles.ts";
import Button from "common/Buttons/Button.tsx";
import styled from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import usePersonalGroupModal from "features/bots/Groups/usePersonalGroupModal.tsx";

interface CreatePersonalGroupModalProps {
  open: boolean;
  closeModal: () => void;
  isEdit?: boolean;
  group?: GroupData;
}

const CreatePersonalGroupModal = ({
  open,
  closeModal,
  group,
}: CreatePersonalGroupModalProps) => {
  const isEdit = !!group;
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);
  const { isLoading, isDisabled, onOkClick, nameInput, errorMessage } =
    usePersonalGroupModal({
      onSuccess: closeModal,
      group,
      subGroupType: group?.sub_group_type ?? SubGroupType.PERSONAL,
    });

  const footer = (
    <ButtonsWrapper>
      <Button onClick={closeModal}>{t("buttons.cancel")}</Button>
      <StyledButton
        type="primary"
        $isDisabled={isDisabled}
        onClick={onOkClick}
        loading={isLoading}
      >
        {t("buttons.ok")}
      </StyledButton>
    </ButtonsWrapper>
  );

  return (
    <Modal
      title={
        isEdit
          ? t("modal.edit_personal_group_title")
          : t("modal.create_personal_group_title")
      }
      open={open}
      onCancel={closeModal}
      zIndex={2000}
      footer={footer}
    >
      <Text style={{ marginBottom: 4 }}>{t("modal.name_label")}</Text>
      {nameInput}
      {errorMessage}
    </Modal>
  );
};

export default CreatePersonalGroupModal;

const ButtonsWrapper = styled(Flex)`
  justify-content: flex-end;
  column-gap: 8px;
`;
const StyledButton = styled(Button)<{ $isDisabled?: boolean }>`
  ${(p) => p.$isDisabled && disabledStyle};
`;
